<script lang="ts">
    
    import { navigate } from "svelte-navigator";

    export let backUrl: string = undefined;

    function onBack() {
        if (backUrl) {
            navigate(backUrl);
            return;
        }
        navigate(-1);
    }

</script>

<style lang="scss">

    @use '../variables';

    $height: 100px;

    .topbar {
        height: $height;
        display: flex;
        color: #fff;
        background-color: variables.$color-primary;

        :global(button) {
            border: 0;
            display: block;
            width: 100%;
            height: 100%;
            background-color: transparent;
            color: #fff;
        }
    }

    .left, .right {
        width: $height;
    }

    .center {
        flex: 1 1 0;
        text-align: center;
        line-height: $height;
    }

    .logo {
        height: 60px;
    }

</style>

<div class="topbar">
    <div class="left">
        <slot name="left">
            <button type="button" on:click={onBack}>
                <img src="/images/back.svg" alt="">
            </button>
        </slot>
    </div>
    <div class="center">
        <img class="logo" src="/images/logo.svg" alt="">
    </div>
    <div class="right">
        <slot name="right" />
    </div>
</div>

